export default "__VITE_ASSET__CLJTorih__"